import style from "../../Pages/ServicesDisplay.module.css";

import billPayment from "../images/ServiceDetailImg/billpayment.png";

const BillPayment = () => {
  return (
    <article className={style.ServiceDetailArticle}>
      <h1>Bill Payment</h1>
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "100%",
          justifyContent: "center",
        }}
      >
        <picture>
          <img src={billPayment}></img>
        </picture>
      </div>
      <p className={style.Paragraph}>
        <strong>
          Bringing a revolution in India's bill payment market, Bharat BillPay
          enables every citizen to pay their different bills under the same
          window.
        </strong>
        <br /> <br />
        This unified ecosystem brings banks, non-banks and online payment
        platforms under one roof as its official authorised units for bill
        collections. BBPS Partners.Bharat Bill Payment System (BBPS) is an
        integrated bill payment system in India offering interoperable and
        accessible bill payment service to customers through a network of agents
        of registered member as Agent Institutions (AI),[1] enabling multiple
        payment modes, and providing instant confirmation of payment.[2]
        National Payments Corporation of India (NPCI) functions as the
        authorised Bharat Bill Payment Central Unit (BBPCU), which will be
        responsible for setting business standards, rules and procedures for
        technical and business requirements for all the participants. NPCI, as
        the BBPCU, will also undertake clearing and settlement activities
        related to transactions routed through BBPS. Existing bill aggregators
        and banks are envisaged to work as Operating Units to provide an
        interoperable bill payment system irrespective of which unit has
        on-boarded a particular biller. Payments may be made through the BBPS
        using cash, transfer cheques, and electronic modes.
      </p>
    </article>
  );
};

export default BillPayment;
